import __axios from "axios";
import { axiosV2 } from "config/@axios";
import * as uiActions from "store/actions/uiActions";
import { toId } from "utils/idFixer";

export const FETCH_SINGLE_MESSAGE = "messageActions::fetchSingle";
export const FETCH_SINGLE_MESSAGE_SUCCESS =
  "messageActions::fetchSingleSuccess";
export const FETCH_SINGLE_MESSAGE_FAILED = "messageActions::fetchSingleFailed";

export const DOWNLOAD_ALL_ATTACHMENTS =
  "messageActions::downloadAllAttachments";
export const DOWNLOAD_ALL_ATTACHMENTS_SUCCESS =
  "messageActions::downloadAllAttachmentsSuccess";
export const DOWNLOAD_ALL_ATTACHMENTS_FAILED =
  "messageActions::downloadAllAttachmentsFailed";

const CancelToken = __axios.CancelToken;
let cancel;

export const fetchSingleMessage =
  ({ folder, id, silent = false }) =>
  dispatch => {
    cancel && cancel();
    id = toId(id);

    dispatch({
      type: FETCH_SINGLE_MESSAGE,
      payload: {
        id,
        silent
      }
    });

    return axiosV2
      .get(`/messages/${id}`, {
        params: {
          folder
        },
        cancelToken: new CancelToken(function executor(e) {
          cancel = e;
        })
      })
      .then(response => {
        const singleMessage = {
          ...response.data,
          parts:
            response.data?.attachments?.filter(
              item => item.disposition !== "inline"
            ) || [],
          size: response.data?.content?.length
        };
        dispatch({
          type: FETCH_SINGLE_MESSAGE_SUCCESS,
          payload: {
            folder,
            id,
            singleMessage
          }
        });

        return singleMessage;
      })
      .catch(err => {
        if (__axios.isCancel(err)) {
          return;
        }

        dispatch({
          type: FETCH_SINGLE_MESSAGE_FAILED,
          payload: {
            id,
            errorText: err.errorMessage
          }
        });
      })
      .finally(() => {
        cancel = null;
      });
  };

export const downloadAllAttachments = id => async dispatch => {
  dispatch({
    type: DOWNLOAD_ALL_ATTACHMENTS,
    payload: { id }
  });

  try {
    const response = await axiosV2.get(`/messages/${id}/attachments/_zip`, {
      responseType: "blob"
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    let fileName = `${id}.zip`;
    const contentDisposition = response.headers["content-disposition"];
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (fileNameMatch && fileNameMatch.length === 2) {
        fileName = fileNameMatch[1];
      }
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);

    dispatch({
      type: DOWNLOAD_ALL_ATTACHMENTS_SUCCESS,
      payload: { id }
    });
  } catch (err) {
    dispatch({
      type: DOWNLOAD_ALL_ATTACHMENTS_FAILED,
      payload: { id, errorMessage: err?.errorMessage }
    });

    dispatch(
      uiActions.addSnackbar({
        message: err?.errorMessage
      })
    );
  }
};
